module.exports = __webpack_public_path__ + "media/images/infinite_shop-2023-91c6fa3adf35c81134f93a158d1e747f.png";